export const multiItemsCellTheme = {
  bg: 'palette.surface.5',
  borderColor: 'palette.transparent',
  borderRadius: '12px',
  borderWidth: '0px',
  tag: {
    bg: 'palette.tertiary.10',
    borderColor: 'palette.tertiary.20',
    borderRadius: '16px',
    borderWidth: '1px',
    text: 'palette.tertiary.80',
  },
};
